<template>
<span v-if="remedial">    
     <!-- case 'createdto':
       
      case 'createdby':
       
      case 'lodgedto':
      
      case 'lodgedby': -->
       
        <p v-if="remedial.shortid">
          Unique Id: <b>{{remedial.shortid}}</b> Status: <span :class="remedial.status | statustype('colour')"><b>{{remedial.status | statustype('name') }}</b></span>    
        </p>
     
        <p>
          <label >{{remedial.type | remedialtype}}: <b>{{remedial.linkedbusiness.name}}</b> <span v-if="remedial.linkedstatus" :class="remedial.linkedstatus | statustype('colour')">(<b>{{remedial.linkedstatus | statustype('name')}}</b>)</span></label> 
        </p>
       
        
        
        <!-- <p>
          <label >Status</label>
          <input type="text" class="w3-input w3-border" style="resize:none" v-model="remedial.Status"/>            
        </p>  -->
        <!-- <p v-if="remedial.type==='lodgedto'">         
          <span v-if="!remedial.id">
            <label >{{remedial.type | remedialtype}} </label>
            <businesses-links-list type="lodge" v-model="remedial.linkedbusiness" />
          </span>    
        </p>    -->

        <span v-if="remedial.type==='createdby'">      
          <p>  
            <label>Job/Remedial# : <b>{{remedial.jobnumber}}</b></label>
          </p>        
          <p>
            <label>PO/Reference # : <b>{{remedial.referencenumber}}</b></label>            
          </p>
          <p>                      
            <label >Issue: <b>{{remedial.issue}}</b></label>            
          </p> 
          <p>                    
            <label >Contact Info: <b>{{remedial.address}}</b></label>                        
          </p> 

          <p>                    
            <label >Assigned <span v-if="remedial.assigned"><b>({{remedial.assigned.knownAs}})</b></span></label>                      
          </p> 
          
        </span>

        <span v-if="remedial.type==='lodgedby'">      
          <p>
            <label>Job/Remedial#</label>
            <input type="text" class="w3-input w3-border" style="resize:none" v-model="remedial.jobnumber"/>            
          </p>        
          <p>
            <label>PO/Reference # : <b>{{remedial.referencenumber}}</b></label>            
          </p>
          <p>                      
            <label >Issue: <b>{{remedial.issue}}</b></label>            
          </p> 
          <p>                    
            <label >Contact Info: <b>{{remedial.address}}</b></label>                        
          </p> 
          
        </span>
        
        <!-- <p v-if="remedial.type==='createdby'">
            <label >Requested by</label>
            <businesses-links-list type="linked" v-model="remedial.linkedbusiness" />
        </p>    -->

        <span v-if="remedial.type==='lodgedto' || remedial.type==='createdto'">       
          <p v-if="remedial.type==='createdto'">
            <label>Job/Remedial#</label>
            <input type="text" class="w3-input w3-border" style="resize:none" v-model="remedial.jobnumber"/> 
          </p>  
          <p>
            <label>PO/Reference #</label>
            <input type="text" class="w3-input w3-border" style="resize:none" v-model="remedial.referencenumber"/>            
          </p> 
          <p>
            <label>issue</label>
            <textarea rows="3" class="w3-input w3-border" style="resize:none" v-model="remedial.issue"/>            
          </p> 
          <p>
            <label>Address of issue</label>
            <textarea rows="3" class="w3-input w3-border" style="resize:none" v-model="remedial.address"/>                     
          </p>
          <p>
              <label >Assigned <span v-if="remedial.assigned"><b>({{remedial.assigned.knownAs}})</b></span></label>
              <installers-group v-model="remedial.assigned" :business="remedial.business"/>              
          </p>
          <!-- <p>
              <label >Advised</label>
              <input type="checkbox" class="w3-check" v-model="remedial.advised"/>            
          </p>        -->
          <p>
              <label >Chargable</label>
              <input type="checkbox" class="w3-check" v-model="remedial.chargeable"/>            
          </p> 
        </span>
       

        <slot></slot>        
        <p v-if="remedial.lastUpdatedAt">
          <b v-if="remedial.lastUpdatedBy">{{remedial.lastUpdatedBy.name}} </b>last updated - <b>{{remedial.lastUpdatedAt|formatDate}}</b><br>
        </p>

  </span>

</template>

<script>
  export default {    
    props: ["remedial","mode","statuses"]    
  }
</script>
 


// WEBPACK FOOTER //
// src/components/shared/controls/layouts/RemedialLayout.vue